/**
 * Factory for creating EventService instances based on platform
 */

import { container } from 'tsyringe';
import NativeEventService from './nativeEventService/NativeEventService';
import WebEventService from './webEventService/WebEventService';
import IEventService from './IEventService';

/**
 * Parameters for creating EventService strategies
 */
export interface IEventServiceFactoryParams {
  isNative: boolean;
}

/**
 * Factory Pattern to encapsulate EventService creation logic
 */
export class EventServiceFactory {
  /**
   * Creates the appropriate EventService based on the platform
   */
  static createService(params: IEventServiceFactoryParams): IEventService {
    const { isNative } = params;

    if (isNative) {
      return container.resolve(NativeEventService);
    } else {
      return container.resolve(WebEventService);
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['NativeEventService', 'WebEventService'];
  }
}
